import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './store';
import { ArtifactTreeProvider } from './contexts/ArtifactTreeContext';
import { PrimeModelProvider } from './contexts/PrimeModelContext';
import { TreeStateProvider } from './contexts/TreeStateContext';
import { UserProvider } from './contexts/UserContext';
import { ChatProvider } from './contexts/ChatContext';
import { ChatUIProvider } from './contexts/ChatUIContext';
import { ModelSelectorProvider } from './contexts/ModelSelectorContext';
import { DataConnectionProvider } from './contexts/DataConnectionContext';
import { CommandProvider } from './contexts/CommandContext';
import { NavigationProvider } from './contexts/NavigationContext';
import { EnhancedAppRoutes } from './routing/enhanced-routes';
import { AppLayoutProvider } from './components/AppShell';
import { DesignThemeProvider } from './components/UI/DesignThemeProvider';
import { UserTimeProvider } from './contexts/UserTimeContext';
import { CaptureLandingSourceKey } from './components/Landing/CaptureLandingSourceKey';
import './App.css';

const App: React.FC = () => {
  return (
    <Provider store={store}>
      <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <CaptureLandingSourceKey />
        <UserProvider>
          <UserTimeProvider>
          <DesignThemeProvider>
          <ChatUIProvider>
            <ModelSelectorProvider>
              <DataConnectionProvider>
                <ChatProvider>
                <NavigationProvider>
                  <CommandProvider>
                    <ArtifactTreeProvider>
                      <PrimeModelProvider>
                        <TreeStateProvider>
                          <div className="App" data-testid="app-container">
                            <AppLayoutProvider>
                              <EnhancedAppRoutes />
                            </AppLayoutProvider>
                          </div>
                        </TreeStateProvider>
                      </PrimeModelProvider>
                    </ArtifactTreeProvider>
                  </CommandProvider>
                </NavigationProvider>
                </ChatProvider>
              </DataConnectionProvider>
            </ModelSelectorProvider>
          </ChatUIProvider>
          </DesignThemeProvider>
          </UserTimeProvider>
        </UserProvider>
      </Router>
    </Provider>
  );
};

export default App;
